import { useCallback } from 'react';

import { PolicyType } from '../PrivacyPolicyText';
import { confirm } from '../utils/confirm';
import { isMobile } from '../../../utils/mobile';

/**
 * Open the privacy policy or terms of use page.
 * @returns A function that opens the privacy policy or terms of use page.
 */
export const useOpenPolicy = () => {
  const openPolicy = useCallback(async (type: PolicyType) => {
    const url =
      type === PolicyType.PrivacyPolicy ? 'https://getjerry.com/privacy-policy/' : 'https://getjerry.com/terms-of-use/';

    if (isMobile(navigator.userAgent)) {
      const shouldOpen = await confirm();
      if (shouldOpen) {
        window.open(url, '_blank');
      }
    } else {
      window.open(url, '_blank');
    }
  }, []);

  return openPolicy;
};
